import { SkechersSizeWiseModel } from "./skechers-size-wise data";

export class SkechersOrderDataModel {

    id: number;
    poNumber: string;
    poStyle: string;
    deliveryAddress: any;
    sizeWiseData: SkechersSizeWiseModel[]
    size: string;
    color: string;
    exFactoryDate?: any;
    deliveryDate?: any;
    quantity?: any;
    status?: any;
    constructor(
        id: number,
        poNumber: string,
        poStyle: string,
        deliveryAddress: string,
        sizeWiseData: SkechersSizeWiseModel[],
        size: string,
        color: string,
        exFactoryDate?: string,
        deliveryDate?: string,
        quantity?: string,
        status?: any,

    ) {
        this.id = id
        this.poNumber = poNumber
        this.poStyle = poStyle
        this.deliveryAddress = deliveryAddress
        this.sizeWiseData = sizeWiseData
        this.color = color
        this.size = size
        this.exFactoryDate = exFactoryDate
        this.deliveryDate = deliveryDate
        this.quantity = quantity
        this.status = status
    }
}


